import { render } from "./CardColumn.vue?vue&type=template&id=4575cbf3"
const script = {}

import exportComponent from "/home/datakepler/public_html/deploy-cache/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__